<template>
  <div class="search">
    <Form label-position="top" ref="form" :model="formData">
      <Row type="flex" :gutter="80">
    
        <!-- <Col :span="6">
          <FormItem label="部门名称" prop="deptName">
            <Input  v-model="formData.deptName"  />
          </FormItem>
        </Col> -->
        <Col :span="6">
          <FormItem label="管理员姓名"  prop="userName">
            <Input  v-model="formData.userName"  />
          </FormItem>
        </Col>
        <Col :span="6">
          <FormItem label="手机号码"   prop="phoneNO">
            <Input  v-model="formData.phoneNO"  />
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
import api from '../../../api/index'
const {getDeptList} = api
export default {
  props: ['depts'],
    data() {
        return {
          formData: {
      
            // deptName: '',
            phoneNO: '',
            userName: ''
          }
        }
    },
    created() {
        
    },
    methods: {
        reset() {
          this.$refs.form.resetFields()
        }
    }
};
</script>

<style>
.search {
  background: #fff;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 24px 20px 0 20px;
}
</style>